import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteAssessment = {
  name: "deleteAssessment" as const,

  input: z.object({ assessmentId: zExt.objectId() }),

  output: z.object({ success: z.boolean() }),
};
